import React, { Component } from "react";
import { inject, observer } from "mobx-react"
import { Row, Col } from "react-styled-flexboxgrid"
import styled from "styled-components"
import Router from "next/router"

import TABLE_SIZES from "./Grid/outterTableSizesRow"
import withTranslations from "~/components/_hocs/withTranslations";
import WinItButton from "~/components/WinItButton"
import Spacer from "~/components/Spacer"
import PlateSelector from "~/components/parking/Landing/Forms/PlateSelector"
import {
  SEARCH_OPTIONS_COMPONENTS,
  SEARCH_COLUMNS_BY_TYPE
} from "./Elements/searchConfig"
import { PARKING_SEARCH_TYPE } from "~/utilities/constants"
import TrafficTicketRedirectDialog, {
  isTrafficTicketNumber
} from "./TrafficTicketRedirectDialog"

const Form = styled.form`
  -webkit-appearance: none;
`

const ButtonSpacer = styled.div`
  height: 52px;
  ${props => props.theme.media.mobile`
    height: 30px;
  `}
`

@inject(all => ({
  isMobile: all.store.ui.isMobile,
  currentHost: all.store.ui.currentHost,
  isLoading: all.store.parkingFlow.results.service.isLoading,
  activeSearchType: all.store.parkingFlow.searchCriteria.type,
  ticketId: all.store.parkingFlow.searchCriteria.ticketId,
  fetchTickets: all.store.parkingFlow.searchCriteria.fetchTickets,
  setPlateState: all.store.parkingFlow.searchCriteria.setPlateState,
  setPlateNumber: all.store.parkingFlow.searchCriteria.setPlateNumber
}))
@observer
class ParkingSearchFormContainer extends Component {
  constructor() {
    super()
    this.submitButtonRef = React.createRef()
    this.state = { showTrafficRedirect: false }
  }

  closeTrafficRedirect = () => this.setState({ showTrafficRedirect: false })

  submitForm = e => {
    if (e && e.preventDefault) e.preventDefault()
    if (this.props.isLoading) {
      return false
    }

    // Traffic (TVB) ticket numbers entered into the parking search by mistake:
    // offer to redirect instead of running a parking lookup.
    if (
      this.props.activeSearchType === PARKING_SEARCH_TYPE.ticketId &&
      isTrafficTicketNumber(this.props.ticketId)
    ) {
      this.setState({ showTrafficRedirect: true })
      return false
    }

    Router.prefetch("/parking/results")
    return this.props.fetchTickets(Router.pathname, this.props.currentHost).then(success => {
      if (success) {
        Router.push("/parking/results")
      }
    })
  }

  handleEnterSubmit = e => {
    if (e.key !== 'Enter' || this.props.isLoading) return
    e.preventDefault()
    this.submitForm(e)
  }

  populateAndSubmitForm = (plateNumber, plateState) => {
    this.props.setPlateNumber(plateNumber)
    this.props.setPlateState(plateState)
    this.submitForm()
  }

  componentDidMount = () => {
    if (this.props.queryPlateNumber && this.props.queryPlateState) {
      this.populateAndSubmitForm(this.props.queryPlateNumber, this.props.queryPlateState)
    }
  }

  render() {
    return (
      <>
        <Form onSubmit={this.submitForm}>
          {this.props.activeSearchType === PARKING_SEARCH_TYPE.plate && (
          <PlateSelector selectPlate={(plateNumber, plateState) => {
          this.populateAndSubmitForm(plateNumber, plateState)
        }}
          />
)}
          <Row>
            {SEARCH_COLUMNS_BY_TYPE[this.props.activeSearchType].map(item => {
            const ColumnComponent = SEARCH_OPTIONS_COMPONENTS[item]
            return (
              <Col {...TABLE_SIZES.inputColumn} key={item}>
                <Spacer mobile={15} desktop={15} />
                <ColumnComponent
                  submitButtonRef={this.submitButtonRef}
                  onEnterSubmit={this.handleEnterSubmit}
                />
              </Col>
            )
          })}

            <Col {...TABLE_SIZES.button}>
              <ButtonSpacer />
              <WinItButton
                isMobile={this.props.isMobile}
                width="100%"
                maxWidth="364px"
                height={70}
                fontSize="1rem"
                type="submit"
                onClick={this.submitForm}
                ref={this.submitButtonRef}
                disabled={this.props.isLoading}
              >
                {this.props.isLoading
                ? this.props.translate('submit.loading') 
                : this.props.translate('submit.search')}
              </WinItButton>
            </Col>

            <Col {...TABLE_SIZES.nothing} />
          </Row>
        </Form>
        <TrafficTicketRedirectDialog
          open={this.state.showTrafficRedirect}
          onClose={this.closeTrafficRedirect}
        />
      </>
    )
  }
}

export default withTranslations(ParkingSearchFormContainer, 'form.general')
